import { Alert, Col, Row } from 'antd';

const PaymentCancel = () => {
  return (
    <div
      style={{
        width: '95%',
        margin: '0 auto',
      }}
    >
      <Row>
        <Col xs={12}>
          <Alert
            message="Payment Cancelled"
            description="Your payment for the tax return has been canceled. Please proceed when you're ready to complete the payment."
            type="error"
            showIcon
          />
        </Col>
      </Row>
    </div>
  );
};

export default PaymentCancel;
